/**
 *  @class
 *  @function Predictive Search
 */
if (!customElements.get("slideshow-search-form")) {
  class SlideshowSearchForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form[action="/search"]'); // Select by form attribute
      this.input = this.querySelector(".slideshow-search-input"); // Select by class
      this.predictiveSearchResults = this.querySelector(
        ".home-slideshow-thb-predictive-search"
      );
      this.slideshow = this.closest(".home-slideshow-wrapper");

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.form.addEventListener("submit", this.onFormSubmit.bind(this));

      // Add class on input focus and prevent event propagation
      this.input.addEventListener("focus", (event) => {
        event.stopPropagation();
        this.slideshow.classList.add("search-is-active");
        this.open();
      });

      // Add class on input click and prevent event propagation
      this.input.addEventListener("click", (event) => {
        event.stopPropagation();
        this.slideshow.classList.add("search-is-active");
      });

      // Add class on form click and prevent event propagation
      this.form.addEventListener("click", (event) => {
        event.stopPropagation();
        this.slideshow.classList.add("search-is-active");
      });

      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
          this.slideshow.classList.add("search-is-active"); // Ensure class remains during typing
        }, 300).bind(this)
      );

      // Prevent clicks inside results from removing the class
      this.predictiveSearchResults.addEventListener("click", (event) => {
        event.stopPropagation();
        this.slideshow.classList.add("search-is-active");
      });

      // Add a click handler for the entire search form component
      this.addEventListener("click", (event) => {
        event.stopPropagation();
        this.slideshow.classList.add("search-is-active");
      });

      // Only remove class when clicking outside
      document.addEventListener("click", (event) => {
        // Debug check to verify we're catching clicks outside correctly
        if (!this.contains(event.target) && !this.predictiveSearchResults.contains(event.target)) {
          this.close();
          this.slideshow.classList.remove("search-is-active");
        }
      });

      document.addEventListener("keyup", (e) => {
        if (e.code && e.code.toUpperCase() === "ESCAPE") {
          this.close();
          this.slideshow.classList.remove("search-is-active");
        }
      });
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        document.body.classList.remove("home-slideshow-open-search");
        this.predictiveSearchResults.setAttribute("inert", "");
        return;
      }
      document.body.classList.add("home-slideshow-open-search");
      this.predictiveSearchResults.removeAttribute("inert");
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      this.predictiveSearchResults.classList.add("loading");

      fetch(
        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
          searchTerm
        )}&${encodeURIComponent(
          "resources[type]"
        )}=page,product,article,query,collection&${encodeURIComponent(
          "resources[limit]"
        )}=10&section_id=predictive-search&${encodeURIComponent(
          "resources[options][fields]"
        )}=title,body`
      )
        .then((response) => {
          this.predictiveSearchResults.classList.remove("loading");
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      let submitButton = this.querySelector("#search-results-submit");

      submitButton.addEventListener("click", () => {
        this.form.submit();
      });
    }

    close() {
      this.predictiveSearchResults.setAttribute("inert", "");
      document.body.classList.remove("home-slideshow-open-search");
    }
    open() {
      document.body.classList.add("home-slideshow-open-search");
      this.predictiveSearchResults.removeAttribute("inert");
    }
  }
  customElements.define("slideshow-search-form", SlideshowSearchForm);
}
